import React from 'react';
import { IIconProps, sizeMap } from './types';

export const InfoOutline = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="-1 -1 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="9" fillOpacity={0} stroke="currentColor" strokeWidth={sizeMap[size].strokeWidth} />
    <rect x="7.875" y="7.3125" width="2.25" height="7.875" rx="1.125" fill="currentColor" />
    <rect x="7.875" y="3.9375" width="2.25" height="2.25" rx="1.125" fill="currentColor" />
  </svg>
);
